(() => {
  if (customElements.get('a5-cuscus-product')) return;
  class CuscusProduct extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.events = new AbortController();
      this.signal = this.events.signal;
      this.variant = this.querySelector('[data-csc-variant]');
      this.form = this.querySelector('[data-csc-form]');
      this.dialog = this.querySelector('[data-csc-dialog]');
      this.links = [...this.querySelectorAll('[data-csc-enlarge]')];
      this.variant?.addEventListener('change', () => this.updateVariant(), { signal: this.signal });
      this.links.forEach((link, index) => link.addEventListener('click', event => {
        if (!this.dialog?.showModal) return;
        event.preventDefault();
        this.lastFocus = link;
        this.openImage(index);
      }, { signal: this.signal }));
      this.querySelector('[data-csc-close]')?.addEventListener('click', () => this.dialog.close(), { signal: this.signal });
      this.querySelector('[data-csc-previous]')?.addEventListener('click', () => this.showImage(this.imageIndex - 1), { signal: this.signal });
      this.querySelector('[data-csc-next]')?.addEventListener('click', () => this.showImage(this.imageIndex + 1), { signal: this.signal });
      this.dialog?.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      }, { signal: this.signal });
      this.dialog?.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.lastFocus?.focus({ preventScroll: true });
      }, { signal: this.signal });
      this.dialog?.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.showImage(this.imageIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.showImage(this.imageIndex + 1); }
      }, { signal: this.signal });
      const steps = [...this.querySelectorAll('[data-csc-step]')];
      const indicators = [...this.querySelectorAll('[data-csc-indicator]')];
      if ('IntersectionObserver' in window) {
        this.stepObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const index = entry.target.dataset.cscStep;
            indicators.forEach(item => item.classList.toggle('is-active', item.dataset.cscIndicator === index));
          });
        }, { rootMargin: '-20% 0px -40% 0px', threshold: 0 });
        steps.forEach(step => this.stepObserver.observe(step));
        this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting && !entry.target.paused && !document.fullscreenElement && entry.target.webkitPresentationMode !== 'picture-in-picture') entry.target.pause();
        }), { threshold: 0 });
        this.querySelectorAll('video').forEach(video => this.videoObserver.observe(video));
      }
      this.updateVariant();
    }
    updateVariant() {
      const option = this.variant?.selectedOptions[0];
      if (!option) return;
      const positive = option.dataset.positive === 'true';
      this.querySelectorAll('[data-csc-price]').forEach(el => { el.textContent = positive ? option.dataset.price : this.dataset.pendingLabel; });
      this.querySelectorAll('[data-csc-compare]').forEach(el => { el.textContent = option.dataset.compare; });
      const onSale = positive && option.dataset.sale === 'true';
      this.querySelectorAll('[data-csc-reference],[data-csc-saving]').forEach(el => { el.hidden = !onSale; });
      this.querySelectorAll('[data-csc-percent]').forEach(el => { el.textContent = `${option.dataset.percent}%`; });
      this.querySelectorAll('[data-csc-saved]').forEach(el => { el.textContent = option.dataset.saved; });
      const buy = this.querySelector('[data-csc-add]');
      const ready = this.dataset.purchaseReady === 'true';
      const allowed = ready && positive && option.dataset.available === 'true' && option.dataset.high !== 'true' && option.dataset.limit !== 'true';
      if (buy) {
        buy.disabled = !allowed;
        const label = !ready ? this.dataset.pendingLabel : option.dataset.high === 'true' ? this.dataset.consultLabel : option.dataset.limit === 'true' ? this.dataset.limitLabel : option.dataset.available === 'true' ? this.dataset.addLabel : this.dataset.soldLabel;
        buy.querySelector('span').textContent = label;
      }
      this.querySelector('[data-csc-high-note]')?.toggleAttribute('hidden', option.dataset.high !== 'true');
      if (this.variant.options.length > 1 && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    }
    openImage(index) {
      this.showImage(index);
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    showImage(index) {
      if (!this.links.length) return;
      this.imageIndex = (index + this.links.length) % this.links.length;
      const link = this.links[this.imageIndex];
      const image = this.dialog.querySelector('img');
      image.src = link.href;
      image.alt = link.dataset.caption;
      this.dialog.querySelector('[data-csc-caption]').textContent = link.dataset.caption;
      this.dialog.querySelector('[data-csc-count]').textContent = `${this.imageIndex + 1} / ${this.links.length}`;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.stepObserver?.disconnect();
      this.videoObserver?.disconnect();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
      this.connected = false;
    }
  }
  customElements.define('a5-cuscus-product', CuscusProduct);
})();
